import { getLocaleFirstDayOfWeek, TitleCasePipe, WeekDay } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
// import { ListOption } from '../modules/tcm-core.module';
import { ListOptionHelper } from '../helpers/list-option-helper';
import { TranslationService } from './translation.service';
import { ListOption } from '../modules/tcm-core.module/models/options/list-option';

@Injectable({
  providedIn: 'root'
})
export class ListOptionService {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private titleCasePipe: TitleCasePipe,
    private translationService: TranslationService) {
  }

  getApiOptions(): ListOption<number>[] {
    const translation = this.translationService.getApiTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAppointmentStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getAppointmentStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAppointmentTypeGroupOptions(): ListOption<number>[] {
    const translation = this.translationService.getAppointmentTypeGroupTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }
  getSubscriptionTypeGroupOptions(): ListOption<number>[] {
    const translation = this.translationService.getSubscriptionTypeGroupTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  geAppriseApiCallTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getAppriseApiCallTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAppriseApiCallSubTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getAppriseApiCallSubTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAuthorizationsTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getAuthorizationTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAssignedToPatientThroughOptions(): ListOption<number>[] {
    const translation = this.translationService.getAssignedToPatientThroughTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getDefaultPageOptions(): ListOption<number>[] {
    const translation = this.translationService.getDefaultPageTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getDocumentTemplateTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getDocumentTemplateTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getDocumentTemplateEmailSourceOptions(): ListOption<number>[] {
    const translation = this.translationService.getDocumentTemplateEmailSourceTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getDocumentTypeGroupOptions(): ListOption<number>[] {
    const translation = this.translationService.getDocumentTypeGroupTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimUnbundleCodeActionOptions(): ListOption<number>[] {
    const translation = this.translationService.getClaimUnbundleCodeActionTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimBatchStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getClaimBatchStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSchedulingClaimFrequencyOptions(): ListOption<number>[] {
    const translation = this.translationService.getSchedulingClaimFrequencyTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getClaimStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getEligibilityRequestTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getEligibilityRequestTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimInsurancePlanRankOptions() {
    const translation = this.translationService.getClaimInsurancePlanRankTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimInsurancePlanTypeOptions() {
    const translation = this.translationService.getClaimInsurancePlanTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimInsuredBenefitAssignmentCertificationOptions() {
    const translation = this.translationService.getClaimInsuredBenefitAssignmentCertificationTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimInsuredProviderAcceptAssignmentOptions() {
    const translation = this.translationService.getClaimInsuredProviderAcceptAssignmentTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimInsuredReleaseInformationCodeOptions() {
    const translation = this.translationService.getClaimInsuredReleaseInformationCodeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimInsuredSubmitterTypeOptions() {
    const translation = this.translationService.getClaimInsuredSubmitterTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimsGroupFilterOptions(): ListOption<number>[] {
    const translation = this.translationService.getClaimsGroupFilterTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getCommonReportTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getCommonReportTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getCommunicationSourceOptions(): ListOption<number>[] {
    const translation = this.translationService.getCommunicationSourceTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientDocumentStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getPatientDocumentStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getEarSideOptions(): ListOption<number>[] {
    const translation = this.translationService.getEarSideTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getEarSideWithoutBinauralOptions(): ListOption<number>[] {
    const translation = this.translationService.getEarSideTranslations();
    const filteredTranslation = Object.keys(translation)
      .filter(key => key != '3')
      .reduce((res, key) => (res[key] = translation[key], res), {});
    return ListOptionHelper.fromTranslation(filteredTranslation);
  }

  getEarSetupTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getEarSetupTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getEdiModeOptions(): ListOption<number>[] {
    const translation = this.translationService.getEdiModeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getInsurancePriorityOptions(): ListOption<number>[] {
    const translation = this.translationService.getInsurancePriorityTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getIcdCodeOptions(): ListOption<number>[] {
    const translation = this.translationService.getIcdCodesTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getInsuranceProductTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getInsuranceProductTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getInsurancePlanFilingMethodOptions(): ListOption<number>[] {
    const translation = this.translationService.getInsurancePlanFilingMethodTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getLicensePlanTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getLicensePlanTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getLookupTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getLookupTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getNoteStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getNoteStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getNoteTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getNoteTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getOrderLineStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getOrderLineStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getOrderStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getOrderStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSchedulerDefaultViewOptions(): ListOption<number>[] {
    const translation = this.translationService.getSchedulerDefaultViewTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSalesOrderSearchTypeFilteOptions(): ListOption<number>[] {
    const translation = this.translationService.getSalesOrderSearchTypeFilterTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSalesOrderSearchSourceFilteOptions(): ListOption<number>[] {
    const translation = this.translationService.getSalesOrderSearchSourceFilterTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientInsuranceCodeTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getPatientInsuranceCodeTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientOrderStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getPatientOrderStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientPreferredContactOptions(): ListOption<number>[] {
    const translation = this.translationService.getPatientPreferredContactTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getPatientStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPaymentMethodOptions(): ListOption<number>[] {
    const translation = this.translationService.getPaymentMethodTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPaymentTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getPaymentTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPaymentStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getPaymentStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getProductCategoryRankOptions(): ListOption<number>[] {
    const translation = this.translationService.getProductCategoryRankTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }
  geRepairTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getRepairTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getProductKitTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getProductKitTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getProductBundleTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getProductBundleTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientReferringPhysicianPriorityOptions(): ListOption<number>[] {
    const translation = this.translationService.getPatientReferringPhysicianPriorityTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getRepairLocationOptions(): ListOption<number>[] {
    const translation = this.translationService.getRepairLocationTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getReportTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getReportTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getRequireMemberIdTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getRequireMemberIdTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMemberIdFormatOptions(): ListOption<number>[] {
    const translation = this.translationService.getMemberIdFormatTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getLossAndDamageOptionOptions(): ListOption<number>[] {
    const translation = this.translationService.getLossAndDamageOptionTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getReturnOrderLineOptionOptions(): ListOption<number>[] {
    const translation = this.translationService.getReturnOrderLineOptionTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSalesPersonModeOptions(): ListOption<number>[] {
    const translation = this.translationService.getSalesPersonModeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSerializedItemStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getSerializedItemStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getWarrantyPriorityOptions(): ListOption<number>[] {
    const translation = this.translationService.getWarrantyPriorityTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getBenefitTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getBenefitTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSubmitterTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getSubmitterTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getStateAdministrativeLevelOptions(): ListOption<number>[] {
    const translation = this.translationService.getStateAdministrativeLevelTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSsrsFilterTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getSsrsFilterTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getTaxIdTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getTaxIdTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getTokenConditionOptions(): ListOption<number>[] {
    const translation = this.translationService.getTokenConditionTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getWorkQueueTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getWorkQueueTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPureToneDegreeOptions(): ListOption<number>[] {
    const translation = this.translationService.getPureToneDegreeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPureToneFrequencyModifierOptions(): ListOption<number>[] {
    const translation = this.translationService.getPureToneFrequencyModifierTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSpeechSATOptions(): ListOption<number>[] {
    const translation = this.translationService.getSpeechSATTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSalesOrderClaimProcessingStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getSalesOrderClaimProcessingStatusEnumTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getClaimProcessingExecuteSourceOptions(): ListOption<number>[] {
    const translation = this.translationService.getClaimProcessingExecuteSourceEnumTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSpeechSRTOptions(): ListOption<number>[] {
    const translation = this.translationService.getSpeechSRTTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSpeechWordRecognitionOptions(): ListOption<number>[] {
    const translation = this.translationService.getSpeechWordRecognitionTranslations();
    return ListOptionHelper.fromTranslation(translation).orderBy(x => x.value ? 0 : 1);
  }

  getPureToneCategoryOptions(): ListOption<number>[] {
    const translation = this.translationService.getPureToneCategoryTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getImmMidEarReflexOptions() {
    const translation = this.translationService.getImmMidEarReflexTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getRecommendationSideOptions() {
    const translation = this.translationService.getRecommendationSideTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSideExtendedOptions(): ListOption<number>[] {
    const translation = this.translationService.getSideExtendedTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  public getServiceCategoryOptions(): ListOption<number>[] {
    const translation = this.translationService.getServiceCategoryTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  public getRecommendationDurationOptions() {
    const translation = this.translationService.getRecommendationDurationTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getRecommendationEquilibriumTypeOptions() {
    const translation = this.translationService.getRecommendationEquilibriumTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportRecommendationOptions() {
    const translation = this.translationService.getMedicalReportRecommendationTranslations();
    return ListOptionHelper.fromTranslation(translation).orderBy(x => x.value == 1 ? 1 : 0);
  }

  getAppointmentRecommendationOptions() {
    const translation = this.translationService.getAppointmentRecommendationTranslations();
    return ListOptionHelper.fromTranslation(translation).orderBy(x => x.value == 1 ? 1 : 0);
  }

  getQueueStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getQueueStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getInventoryOrderStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getInventoryOrderStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getInventoryOrderLineStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getInventoryOrderLineStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getInventoryOrderTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getInventoryOrdeTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getUnitWeightBasisOptions() {
    const translation = this.translationService.getUnitWeightBasisTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getSACLevelOptions() {
    const translation = this.translationService.getSACLevelTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getYearPurchasedOptions() {
    const translation = this.translationService.getYearPurchasedTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPatientSatisfactionOptions() {
    const translation = this.translationService.getPatientSatisfactionTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportConfirmationOptions() {
    const translation = this.translationService.getMedicalReportConfirmationTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportBinauralDiscriminationOptions() {
    const translation = this.translationService.getMedicalReportBinauralDiscriminationTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPureToneStimulusMethodOptions() {
    const translation = this.translationService.getPureToneStimulusMethodTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportTympOptions() {
    const translation = this.translationService.getMedicalReportTympTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportOutcomeOptions() {
    const translation = this.translationService.getMedicalReportOutcomeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportReturnOptions() {
    const translation = this.translationService.getMedicalReportReturnTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getMedicalReportLevelOptions() {
    const translation = this.translationService.getMedicalReportLevelTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getRecommendationSideFullNameOptions() {
    const translation = this.translationService.getRecommendationSideFullNameEnumTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getPurposeOfVisitOptions() {
    const translation = this.translationService.getPurposeOfVisitTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getImportCsvFileDelimiterOptions() {
    const translation = this.translationService.getImportCsvFileDelimiterTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getTimeSlotTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getTimeSlotTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getTemplateSlotTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getTemplateSlotTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getUnavailableSlotApplyToTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getUnavailableSlotApplyToTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getEndOfDayStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getEndOfDayStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getDispensingPlanModeOptions(): ListOption<number>[] {
    const translation = this.translationService.getDispensingPlanModeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getDaysOfWeekOptions(): ListOption<number>[] {
    const firstDayOfWeek = getLocaleFirstDayOfWeek(this.locale);
    const daysOfWeekTranslations = this.translationService.getDayFullNames();

    var daysOfWeek = new Array<ListOption<number>>(7);
    var currentIndex = 0;

    daysOfWeek[currentIndex++] = this.getDaysOfWeekOption(daysOfWeekTranslations, firstDayOfWeek);

    var currentDayOfWeek = firstDayOfWeek + 1;
    while (currentDayOfWeek <= 6) {
      daysOfWeek[currentIndex++] = this.getDaysOfWeekOption(daysOfWeekTranslations, currentDayOfWeek);
      currentDayOfWeek++;
    }

    currentDayOfWeek = firstDayOfWeek - 1;
    while (currentDayOfWeek >= 0) {
      daysOfWeek[currentIndex++] = this.getDaysOfWeekOption(daysOfWeekTranslations, currentDayOfWeek);
      currentDayOfWeek--;
    }

    return daysOfWeek;
  }

  getMonthOptions(): ListOption<number>[] {

    const monthNames = this.translationService.getMonthFullNames();

    const options: ListOption<number>[] = monthNames.map((m, i) => {
      return {
        value: i + 1,
        displayName: m
      };
    });

    return options;
  }

  getApiRequestTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getApiRequestTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getYesNoOptions(): ListOption<boolean>[] {

    var options = new Array<ListOption<boolean>>();
    options.push(this.getBooleanTextOption(this.translationService.translate(x => x.Controls.Booleans.Yes), true));
    options.push(this.getBooleanTextOption(this.translationService.translate(x => x.Controls.Booleans.No), false));

    return options;
  }

  getErpSystemOptions(): ListOption<number>[] {
    const translation = this.translationService.getErpSystemTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getTaxModeOptions(): ListOption<number>[] {
    const translation = this.translationService.getTaxModeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getBusinessCentralApiCallTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getBusinessCentralApiCallTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getBusinessCentralAuthenticationTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getBusinessCentralAuthenticationTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAppriseApiCallTestTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getAppriseApiCallTestTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getRecallStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getRecallStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  private getBooleanTextOption(translationText: string, value?: boolean): ListOption<boolean> {
    return {
      value: value,
      displayName: translationText,
      parameters: null
    };
  }

  private getDaysOfWeekOption(daysOfWeekTranslations: string[], dayOfWeek: WeekDay): ListOption<number> {
    return {
      value: dayOfWeek,
      displayName: this.titleCasePipe.transform(daysOfWeekTranslations[dayOfWeek]),
      parameters: null
    };
  }

  getIntegrationStatusOptions(): ListOption<number>[] {
    const translation = this.translationService.getIntegrationStatusTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getProductStyleSideOptions(): ListOption<number>[] {
    const translation = this.translationService.getProductStyleSideOptions();
    return ListOptionHelper.fromTranslation(translation);
  }
  getExternalApiCallTypeOptions(): ListOption<number>[] {
    const translation = this.translationService.getExternalApiCallTypeTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getServicePlanPriorityOptions(): ListOption<number>[] {
    const translation = this.translationService.getServicePlanPriorityTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getCreditCardPayOptions(): ListOption<number>[] {
    const translation = this.translationService.getCreditCardPayTranslations();
    return ListOptionHelper.fromTranslation(translation);
  }

  getAdpPersonSignatureOptions(): ListOption<number>[] {
    const translation = this.translationService.getAdpPersonSignatureOptions();
    return ListOptionHelper.fromTranslation(translation);
  }
}
